import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import StartScreenOptions from './StartScreenOptions';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { gtmUserEvent, gtmStartGenericEvent } from 'store/reducers/gtm/actions';
import {
  setAppFlow,
  setLocalizedQuickApptService
} from 'store/reducers/userInteractions/actions';

// Selectors
import { getQuickApptEnabled } from 'store/reducers/userInteractions/selectors';

function mapStateToProps(state) {
  return {
    isQuickApptEnabled: getQuickApptEnabled(state)
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      goTo,
      setAppFlow,
      gtmUserEvent,
      gtmStartGenericEvent,
      setLocalizedQuickApptService
    },
    dispatch
  );
}

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(StartScreenOptions);



// WEBPACK FOOTER //
// ./src/components/molecules/StartScreenOptions/StartScreenOptionsContainer.js